import { useState } from 'react';
import AnimatedPage from '../components/SmoothPage/smooth.js';

import ContactForm from '../components/Form/form.js';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Contacts = () => {
    const [isFormOpen, setIsFormOpen] = useState(false);

    return (
        <AnimatedPage>
            <section className="contacts-modern">
                <div className="contacts-modern__glow"></div>

                <h1 className="contacts-modern__title">Contacts</h1>

                <div className="contacts-modern__grid">
                    <div className="contacts-modern__card">
                        <div className="contacts-modern__icon"><i className="fas fa-map-marker-alt"></i></div>
                        <h3>Location</h3>
                        <p>Ukraine</p>
                    </div>

                    <div className="contacts-modern__card">
                        <div className="contacts-modern__icon"><i className="fab fa-telegram-plane"></i></div>
                        <h3>Telegram</h3>
                        <a href="https://t.me/Napoleon_1109" target="_blank" rel="noopener noreferrer">
                            https://t.me/The_Nova_Team
                        </a>
                    </div>

                    <div className="contacts-modern__card">
                        <div className="contacts-modern__icon"><i className="fab fa-instagram"></i></div>
                        <h3>Instagram</h3>
                        <a href="https://www.instagram.com/novateamweb/?hl=de" target="_blank" rel="noopener noreferrer">
                            instagram.com/novateamweb
                        </a>
                    </div>

                    <div className="contacts-modern__card">
                        <div className="contacts-modern__icon"><i className="fas fa-envelope"></i></div>
                        <h3>Email</h3>
                        <a href="mailto:novateam.web@gmail.com">novateam.web@gmail.com</a>
                    </div>
                </div>
            </section>


            <ContactForm
                isOpen={isFormOpen}
                setIsOpen={setIsFormOpen}
                className="contact-page-form"
            />


        </AnimatedPage>
    );
};

export default Contacts;
